import { AnimationBaseController, IAnimationControllerConfiguration, Inject, SoundType } from "../../../../modules/@denishussar/html5-game-engine";
import { AnalyticsConstants } from "../../../Constants/AnalyticsConstants";
import { GameLogic } from "../../../Logic/GameLogic";
import { GameModel } from "../../../Models/GameModel";
import { scaleModal } from "../../../Utils/DialogScale";
import { AnimationContents } from "../../AnimationContents";
import { ButtonController, IButtonControllerOptions } from "../../Common/ButtonController";

export interface IChooseSkinScreenControllerOptions {

}

export class ChooseSkinScreenController extends AnimationBaseController {
    $model: GameModel
    private _width: number = 0;
    private _height: number = 0;
    constructor(
        @Inject private _gameModel: GameModel,
        @Inject private _options: IChooseSkinScreenControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('ChooseSkinScreenController');
    };

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.CHARACTER_DIALOG_JSON,
            libraryName: "characters_dialog",
            childControllers: {
                ButtonConfirm: {
                    instanceName: "btn_start",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this.startGame();
                        }
                    }

                },
                ButtonChoose: {
                    instanceName: "choice_char",
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            const mov = this.$childControllers.get<AnimationBaseController>('ButtonChoose');
                            mov.gotoAndStop(mov.currentFrame === 0 ? 1 : 0);
                            this.$model.playerGender = mov.currentFrame === 0 ? 'woman' : 'man';

                        }
                    }
                },
                // ButtonSibur: {
                //     instanceName: "btn_sibur",
                //     controller: ButtonController,
                //     model: this.$model,
                //     options: <IButtonControllerOptions> {
                //         onClick: () => {
                //             this.openLink();
                //         }
                //     }
                // }

            },
            modelWatch: {

            }
        }

    }

    onResize(width: number, height: number, scale: number) {
        console.log('resize');
        scaleModal(this, width, height, scale * 1.2, this._width, this._height);
    }

    onInitialize() {
        this._width = 1442;
        this._height = 1139;
        this.scaleX = this.scaleY = 0.8;

        const style = {
            dropShadow: true,
            dropShadowColor: '#5ebed7',
            dropShadowBlur: 4,
            dropShadowAngle: 1.2,
            dropShadowDistance: 6
        };
        this.setTextStyleByQuery('title', style);
        this.setTextStyleByQuery('title_footer', style);

    }

    async openLink() {
        await this._gameLogic.sendAnalitics(AnalyticsConstants.SUPPORT);
        window.open('https://rating.hh.ru/poll/', '_blank');
    }

    async startGame() {
        await this._gameLogic.sendAnalitics(AnalyticsConstants.START);
        this._gameLogic.hideModal();
        this._gameLogic.showTutorial();
    }

}